import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnDestroy, OnInit, Output} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {} from '~core/models/tixx-select/ticket-quota';
import {TicketQuotaService} from '~core/services';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {Lottery, ProcessConfiguration, TicketQuota} from '~core/models';
import {TooltipTranslationService} from '~shared/translations';
import {EventAdministrationService} from "~features/tixx-select/event-administration.service";

/**
 * Handles price categories list.
 */
@UntilDestroy()
@Component({
  selector: 'app-ticket-quota-list',
  templateUrl: './ticket-quota-list.component.html',
})
export class TicketQuotaListComponent implements OnInit, OnDestroy {
  public ticketQuotaList: Array<any> = [];
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public currentProcessConfiguration: ProcessConfiguration;
  public currentTicketQuota: TicketQuota;

  @Input() public selectedLottery: Lottery;
  @Input() public isPanelOpened: boolean = true;
  @Output() public isPanelOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public tablesTranslations: TablesTranslations,
    private tixxSelectOverviewService: EventAdministrationService,
    private ticketQuotaService: TicketQuotaService,
    public tooltipTranslations: TooltipTranslationService,
    @Inject(LOCALE_ID) public locale: string
  ) {
    this.ticketQuotaService.castCurrentTicketQuota
      .subscribe(res => this.currentTicketQuota = res);
    this.columns.push(
      this.tablesTranslations.i18nName,
      this.tablesTranslations.i18nAmount,
      this.tablesTranslations.i18nColor,
    );
    this.keys.push(['name', 'fullPrice', 'color']);
  }

  public ngOnInit(): void {
    this.ticketQuotaService.get(this.selectedLottery).pipe(untilDestroyed(this))
      .subscribe(res => {
        this.ticketQuotaService.setCurrentTicketQuota(res);
      });
  }

  public ngOnDestroy(): void {
  }

  /**
   * Open the create ticket quota modal
   */
  public editTicketQuota(): any {
    this.tixxSelectOverviewService.toggleAllModal(false);
    this.tixxSelectOverviewService.toggleEditTicketQuotaModal(true);
  }
}
